import { Suspense } from 'react';

// project import
import Loader from './Loader';
import ChunkErrorBoundary from './ChunkErrorBoundary';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = (Component) => (props) =>
  (
    <ChunkErrorBoundary>
      <Suspense fallback={<Loader />}>
        <Component {...props} />
      </Suspense>
    </ChunkErrorBoundary>
  );

export default Loadable;
